import React from 'react';
import ModuleScheduleItem from "./module-schedule-item";
import CheckoutContext from "../../checkout-context";

class ModuleSchedule extends React.Component {
    constructor(props) {
        super(props);
    }

    static contextType = CheckoutContext;

    render() {
        const {
            handleCourseClick,
            textsMapping,
            cartLineItems,
            invalidModuleItems
        } = this.context;

        const lineItemsWithPlanner = cartLineItems.filter(item => item.withPlanner);
        const isInitiallyOpen = lineItemsWithPlanner.length === 1;
        const hasInvalidModuleItems = invalidModuleItems.length > 0;

        return (
            <section className="checkout-section module-schedule">
                <h2>{textsMapping.moduleScheduleTitle}</h2>

                <div className="checkout-section">
                    <h3 className="checkout-section__title">
                        {textsMapping.moduleScheduleSubTitle}
                    </h3>

                    <p>{textsMapping.moduleScheduleText}</p>

                    {hasInvalidModuleItems && <p className="module-schedule__invalid-message">{textsMapping.moduleScheduleErrorMessage}</p>}

                    {lineItemsWithPlanner.map(moduleScheduleItem => (
                        <ModuleScheduleItem
                            key={`moduleScheduleItem${moduleScheduleItem.sku}`}
                            item={moduleScheduleItem}
                            textsMapping={textsMapping}
                            handleCourseClick={handleCourseClick}
                            isInitiallyOpen={isInitiallyOpen}
                            isInvalid={invalidModuleItems.includes(moduleScheduleItem.sku)}
                        />
                    ))}
                </div>
            </section>
        )
    }
}

export default ModuleSchedule;